import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { CookieConsentBannerComponent } from "./shared/components/cookie-consent-banner/cookie-consent-banner.component";
import { PlatformConfigService } from "@core/services/platform-config.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, CookieConsentBannerComponent],
  template: `
    <router-outlet></router-outlet>
    <app-cookie-consent-banner></app-cookie-consent-banner>
  `,
  styles: [],
})
export class AppComponent {
  title = "SEO/AEO Article Generator";
  private platformConfig = inject(PlatformConfigService);

  constructor() {
    this.platformConfig.load();
  }
}
